// login
import axios from '@/libs/api.request'


// 账号名
export const authLogin = (data) => {
  return axios.request({
    data: data,
    url: `/api/auth/login`,
    method: 'post',
    headers: {
      isLogin: true
    }
  })
}
// 退出登录
export const logout = (data) => {
  return axios.request({
    data: data,
    url: `/api/auth/logout`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}
// 登录验证码发送
// export const loginSendAuthCode = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/auth/loginSendAuthCode`,
//     method: 'post',
//     headers: {
//       noEncryption: true
//     }
//   })
// }
// 修改密码验证码发送
// export const resetPasswordSendAuthCode = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/auth/resetPasswordSendAuthCode`,
//     method: 'post'
//   })
// }
// 手机号登录
// export const mobileLogin = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/auth/mobileLogin`,
//     method: 'post',
//     headers: {
//       isLogin: true
//     }
//   })
// }
// 获取租户信息表
export const querySingleTenantInfoByDomainByRequset = (data) => {
  return axios.request({
    data: data,
    url: `/api/tenant/querySingleTenantInfoByDomainByRequset`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}
// 重定向后获取用户信息
export const codeLogin = (data) => {
  return axios.request({
    url: `/api/auth/codeLogin${data}`,
    method: 'get',
    headers: {
      noEncryption: true
    }
  })
}

// 根据用户id获取菜单-当前用户
export const getMenuListByCurrentUser = (data) => {
  return axios.request({
    url: `/api/sys/getMenuListByCurrentUser`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}
// 根据当前选择租户登录
// export const loginByUserIdAndTenantId = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/auth/loginByUserIdAndTenantId`,
//     method: 'post',
//     headers: {
//       isLogin: true
//     }
//   })
// }
// 企业微信oauthLogin方式登录
// export const oauthLogin = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/auth/oauthLogin${data}`,
//     method: 'get',
//     headers: {
//       isLogin: true
//     }
//   })
// }

// 根据手机号 & 验证码修改密码
export const resetPasswdByMobile = (data) => {
  return axios.request({
    data: data,
    url: `/api/user/resetCurrentUserPasswd`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}
// 企业注册

// 注册验证码发送
// export const registerSendAuthCode = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/register/registerSendAuthCode`,
//     method: 'post',
//     headers: {
//       noEncryption: true
//     }
//   })
// }
// 校验验证码并获取注册信息
// export const getRegisterInfo = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/register/getRegisterInfo`,
//     method: 'post',
//     headers: {
//       noEncryption: true
//     }
//   })
// }
// 提交注册信息(简)
// export const commitSimpleRegisterInfo = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/register/commitSimpleRegisterInfo`,
//     method: 'post',
//     headers: {
//       noEncryption: true
//     }
//   })
// }
// 获取风险等级
// export const getLoginRiskControlLevel = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/auth/getLoginRiskControlLevel`,
//     method: 'post',
//     headers: {
//       noEncryption: true
//     }
//   })
// }
// 获取验证图片  以及token
export const captchaGet = (data) => {
  return axios.request({
    data: data,
    url: `/api/captcha/get`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}

// 滑动或者点选验证
export const captchaCheck = (data) => {
  return axios.request({
    data: data,
    url: `/api/captcha/check`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}
// 账号登录短信验证
// export const sendAuthCodeByLoginName = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/auth/sendAuthCodeByLoginName`,
//     method: 'post',
//     headers: {
//       noEncryption: true
//     }
//   })
// }
// 忘记密码短信验证
// export const forgotPasswordSendAuthCode = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/auth/forgotPasswordSendAuthCode`,
//     method: 'post',
//     headers: {
//       noEncryption: true
//     }
//   })
// }
// 忘记重置密码校验完成
// export const resetPasswdByLoginName = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/user/resetPasswdByLoginName`,
//     method: 'post',
//     headers: {
//       noEncryption: true
//     }
//   })
// }
// SSO登录
export const ssologin = (data) => {
  return axios.request({
    data: data,
    url: `/api/auth/ssologin`,
    method: 'post',
    headers: {
      isLogin: true
    }
  })
}

// SSO登录
export const materialSsoLogin = ({ token, code }) => {
  return axios.request({
    url: `/api/auth/materialSsoLogin?code=${code}&token=${token}`,
    method: 'post'
  })
}
